import head from 'lodash/head';
import { Environment } from '@yme/utils/environment';
import { AUTHOR_LINK_PREFIX, FacetFields, NO_IMAGE, SearchParams } from './constants';
export function getBasketItems(entries = []) {
    return entries.map(({ name, quantity, product: { key, variants: [currentVariant], }, }) => ({
        prod_id: key,
        sku: currentVariant.sku,
        name,
        quantity,
        price: head(currentVariant.prices)?.discount?.discountedPrice ??
            head(currentVariant.prices)?.amount,
    }));
}
export function getConversionData(cart, orderId) {
    return {
        basket: {
            items: getBasketItems(cart.entries),
        },
        basket_value: cart.totalPrice.amount,
        currency: cart.currencyCode,
        is_conversion: 1,
        order_id: orderId,
    };
}
export const getSearchParams = () => {
    const params = new URLSearchParams(window.location.search);
    return {
        query: params.get(SearchParams.QUERY) ?? '',
        category: params.get(SearchParams.CATEGORY) ?? '',
        sort: params.get(SearchParams.SORT) ?? '',
        unit_type: params.get(FacetFields.UNIT_TYPE) ?? '',
        collection: params.get(FacetFields.COLLECTION) ?? '',
        type: params.get(FacetFields.TYPE) ?? '',
        subcategories: params.get(FacetFields.SUBCATEGORIES) ?? '',
        gender: params.get(FacetFields.GENDER) ?? '',
        sizes: params.get(FacetFields.SIZES) ?? '',
        colors: params.get(FacetFields.COLORS) ?? '',
        is_discounted: params.get(FacetFields.IS_DISCOUNTED) ?? '',
    };
};
export function getPrimaryTypeFacet(facets) {
    return facets.find((facet) => facet.name === FacetFields.PRIMARY_TYPE)?.value ?? [];
}
export function getFacetCountByName(facets, name) {
    return facets.find((item) => item.name === name)?.count ?? 0;
}
export function checkNoImageUrl(imageUrl) {
    if (imageUrl === NO_IMAGE) {
        return '';
    }
    return imageUrl;
}
export function setDefaultPixelData(brData, accountId, domainKey, type) {
    brData.acct_id = accountId;
    brData.title = document.title;
    brData.domain_key = domainKey;
    brData.orig_ref_url = window.location.href;
    if (type) {
        brData.ptype = type;
    }
    if (!Environment.isProduction()) {
        brData.debug = true;
        brData.test_data = true;
    }
}
export const getPDPLinkForBloomreachAccessory = ({ path, isInAuthor, sku, }) => {
    if (!path) {
        return;
    }
    if (isInAuthor) {
        const parts = path.split('pdp/');
        const slug = parts[1].split('/#')[0];
        const pdpPath = parts[0] + 'pdp';
        const currentSku = sku ? `#${sku}` : '';
        return `${AUTHOR_LINK_PREFIX}${pdpPath}.${slug}.html${currentSku}`;
    }
    return path;
};
